import React from 'react';
import styles from './BagelChatWidget.module.scss';

interface DocPreviewData {
  title: string;
  excerpt: string;
  category?: string;
}

interface BagelDocPreviewBlockProps {
  children: string;
}

/**
 * BagelDocPreviewBlock — renders a ```doc-preview fence as a document excerpt card.
 * Expected JSON content: { "title": "...", "excerpt": "...", "category": "guidelines" }
 * Falls back to plain text if JSON parse fails.
 */
export default function BagelDocPreviewBlock({
  children,
}: BagelDocPreviewBlockProps) {
  let data: DocPreviewData | null = null;

  try {
    data = JSON.parse(children.trim()) as DocPreviewData;
  } catch {
    // Fallback: render as plain pre block
    return (
      <pre className={styles.docPreviewFallback}>
        <code>{children}</code>
      </pre>
    );
  }

  const truncated =
    data.excerpt.length > 200
      ? `${data.excerpt.slice(0, 200).trimEnd()}…`
      : data.excerpt;

  return (
    <div className={styles.docPreviewBlock}>
      <div className={styles.docPreviewHeader}>
        <span className={styles.docPreviewIcon}>📄</span>
        <span className={styles.docPreviewTitle}>{data.title}</span>
        {data.category && (
          <span className={styles.docPreviewBadge}>{data.category}</span>
        )}
      </div>
      <p className={styles.docPreviewExcerpt}>{truncated}</p>
    </div>
  );
}
